import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import withFingerprint from 'components/payment/mexico/claro-pagos/withFingerprint';
import withClaroPayment from 'components/payment/mexico/claro-pagos/withClaroPayment';
import withAxiosClient from 'components/payment/mexico/claro-pagos/withAxiosClient';

import HeaderSection from 'components/user/HeaderSection';
import SuscribeSection from 'components/user/SuscribeSection';
import UnSuscribeSection from 'components/user/UnSuscribeSection';
import PaymentSection from 'components/user/PaymentSection';
import SocialSection from 'components/user/SocialSection';

import * as actionsUser from 'action-creators/user';
import * as actionsCard from 'action-creators/card';
import LoadingBlocks from 'components/forms/LoadingBlocks';
import { GetRegion } from 'constants.js';
import Utils from 'utils/Utils';

import Devices from './Devices';
import Password from './Password';
import Profile from './Profile';
import ControlPin from './ControlPin';
import RentHistory from './RentHistory';
import PublicProfile from './PublicProfile';
import NavigationWrapper from '../../components/NavigationWrapper';
import getFirstNode from 'utils/getFirstNode';

const AAPL_DEVICE_MODEL = 'aapl';
const REGION_MEX = 'mexico';

const MyAccount = props => {
  const [pathLoad, setPathLoad] = useState(0);

  useEffect(() => {
    props.fetchPaywayData(props.config);
    props.isLoggedIn(props.metadata);
    props.fetchPaywayListPaymentMethod(props.config);
    props.fetchPurchaseSusc(props.config);
  }, []);

  useEffect(
    () => { // scroll section  site full charge
      if (props.location?.hash) {
        const element = document.querySelector(props.location?.hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }
    },
    [props.location, pathLoad],
  );

  // scoll section first load
  const scrollLoad = () => {
    if (pathLoad < 8) {
      setPathLoad(pathLoad + 1);
    }
  };

  const renderPaymentSection = (region, metadata) => {
    if (region === REGION_MEX) {
      return <PaymentSection metadata={metadata} />;
    }
    return null;
  };

  const isAndroid = props?.queryParams?.device_model === 'android';
  const hasSavedPaymentMethod =
    props?.user?.hasSavedPayway &&
    props?.user?.profile?.paymentMethods?.filter(
      item => item?.gateway !== 'codigopromocional',
    ).length > 0;

  if (props?.user == null && props?.metadata == null) {
    return <LoadingBlocks />;
  }

  if (!props.user.isAdmin) {
    const firstNode = getFirstNode();

    window.location.href = `/${GetRegion()}/${firstNode}`;
  }

  const myAccountConfig = props?.metadata?.myaccount_configuration;
  let myConf = null;

  if (myAccountConfig) {
    try {
      myConf = JSON.parse(myAccountConfig);
    } catch (e) {
      myConf = null;
    }
  }

  if (myConf) {
    myConf = myConf[GetRegion()] || myConf.default;
  }
  if (myConf) {
    myConf = myConf?.suscription;
  }

  if (myConf) {
    myConf = myConf;
  }
  let suscModules = [];

  if (myConf && props.payway) {
    const canShowSuscriptions =
      !isAndroid || hasSavedPaymentMethod || props.hasSavedPayway === '1';
    if (canShowSuscriptions) {
      suscModules = myConf.reduce((suscs, oferta) => {
        const dataToComponent = oferta;
        // console.log(dataToComponent, 'DTC');
        props.payway.forEach(suscripcion => {
          const isClaro = oferta.provider.toLowerCase().indexOf('cv_') >= 0;
          if (
            oferta?.provider === suscripcion?.producttype &&
            suscripcion?.waspurchase
          ) {
            if (Array.isArray(oferta.keys)) {
              if (oferta.keys.indexOf(suscripcion.key) !== -1) {
                dataToComponent.payway = suscripcion;

                // Hard para el UnsuscribeDeITunes
                // TODO: REFACTOR -> Hay muchos ifs anidados lo que incrementa mucho la complejidad del código
                suscs.push(
                  <UnSuscribeSection
                    key={suscripcion.offer_id}
                    extradata={dataToComponent}
                  />,
                );
              }
            } else {
              dataToComponent.payway = suscripcion;
              // Hard para el UnsuscribeDeITunes
              suscs.push(
                <UnSuscribeSection
                  key={suscripcion.offer_id}
                  extradata={dataToComponent}
                />,
              );
            }
          } else if (
            oferta.provider === suscripcion.producttype &&
            !suscripcion.waspurchase
          ) {
            if (Array.isArray(oferta.keys)) {
              if (oferta.keys.indexOf(suscripcion.key) !== -1) {
                dataToComponent.selectedOfferid = suscripcion.offer_id;
                if (!isClaro && !oferta.default_offer_id) {
                  dataToComponent.default_offer_id = Utils.getExternalProviderOffers(
                    oferta.provider,
                    props.payway,
                  ).join(',');
                }
                suscs.push(
                  <NavigationWrapper>
                    <SuscribeSection
                      key={suscripcion.offer_id}
                      extradata={dataToComponent}
                      purchase={props.pbisusc}
                    />
                  </NavigationWrapper>,
                );
              }
            } else {
              dataToComponent.selectedOfferid = suscripcion.offer_id;
              if (!isClaro && !oferta.default_offer_id) {
                dataToComponent.default_offer_id = Utils.getExternalProviderOffers(
                  oferta.provider,
                  props.payway,
                ).join(',');
              }
              suscs.push(
                <NavigationWrapper>
                  <SuscribeSection
                    key={suscripcion.offer_id}
                    extradata={dataToComponent}
                    purchase={props.pbisusc}
                  />
                </NavigationWrapper>,
              );
            }
          }
        });
        return suscs;
      }, []);
    }
  }

  const deviceModel = props?.queryParams?.device_model;

  return (
    <div onLoad={() => scrollLoad()}>
      <HeaderSection />
      {suscModules}
      {renderPaymentSection(GetRegion(), props.metadata)}
      <Profile />
      <Password />
      <PublicProfile />
      {deviceModel !== AAPL_DEVICE_MODEL && !window.Android && (
        <SocialSection />
      )}
      <Devices />
      <ControlPin />
      {deviceModel !== AAPL_DEVICE_MODEL && <RentHistory />}
    </div>
  );
};

MyAccount.propTypes = {
  isLoggedIn: PropTypes.func,
  fetchPaywayData: PropTypes.func,
  fetchPaywayListPaymentMethod: PropTypes.func,
  fetchPurchaseSusc: PropTypes.func,
  pbisusc: PropTypes.shape({
    bannerpromo: PropTypes.string,
  }),
  payway: PropTypes.arrayOf(PropTypes.shape({})),
  config: PropTypes.shape({
    environment: PropTypes.string,
  }),
  queryParams: PropTypes.shape({
    device_model: PropTypes.string,
  }),
  metadata: PropTypes.shape({
    myaccount_configuration: PropTypes.string,
    socialization_enabled: PropTypes.string,
  }),
  user: PropTypes.shape({
    info: PropTypes.shape({
      gamification_id: PropTypes.string,
    }),
  }),
};

const mapStateToProps = state => ({
  metadata: state.metadata,
  user: state.user,
  config: state.config,
  payway: state.user.paywayData,
  pbisusc: state.card.purchaseInfoSusc,
  estado: state,
});

const mapDispatchToProps = dispatch => ({
  isLoggedIn(metadata) {
    dispatch(actionsUser.isLoggedIn(metadata));
  },
  fetchPaywayData(config) {
    dispatch(actionsUser.fetchPaywayData(config));
  },
  fetchPurchaseSusc(config) {
    dispatch(actionsCard.fetchPurchaseSusc(config));
  },
  fetchPaywayListPaymentMethod(config) {
    dispatch(actionsUser.fetchPaywayListPaymentMethod(config));
  },
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withAxiosClient,
  withClaroPayment,
  withFingerprint,
)(MyAccount);
